(function () {
	function slugify(text) {
		var characterMap = {
			'ß': 'ss', 'ẞ': 'ss', 'æ': 'ae', 'Æ': 'ae', 'ø': 'o', 'Ø': 'o', 'å': 'a', 'Å': 'a',
			'ð': 'd', 'Ð': 'd', 'þ': 'th', 'Þ': 'th', 'ł': 'l', 'Ł': 'l', 'đ': 'd', 'Đ': 'd'
		};

		return text
			.replace(/[ßẞæÆøØåÅðÐþÞłŁđĐ]/g, function (character) {
				return characterMap[character] || character;
			})
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.replace(/[^a-z0-9\s-]/g, '')
			.trim()
			.replace(/\s+/g, '-')
			.replace(/-+/g, '-');
	}

	function getUniqueId(baseId, usedIds) {
		baseId = baseId || 'section';
		var id = baseId;
		var index = 2;

		while (document.getElementById(id) || usedIds[id]) {
			id = baseId + '-' + index;
			index += 1;
		}

		usedIds[id] = true;
		return id;
	}

	function getItemNumber(item, previousItem, counters, flatCounter, nested) {
		if (!nested) {
			return flatCounter + 1;
		}

		if (!previousItem || item.depth <= previousItem.depth) {
			Object.keys(counters).forEach(function (depth) {
				if (Number(depth) > item.depth) {
					delete counters[depth];
				}
			});
		}

		counters[item.depth] = (counters[item.depth] || 0) + 1;
		return counters[item.depth];
	}

	function scrollToHeading(heading, offset) {
		var top = heading.getBoundingClientRect().top + window.pageYOffset - offset;

		window.scrollTo({
			top: Math.max(top, 0),
			behavior: 'smooth'
		});

		if (history.pushState) {
			history.pushState(null, '', '#' + encodeURIComponent(heading.id));
		}
	}

	function getHeadingUrl(headingId) {
		return window.location.href.split('#')[0] + '#' + encodeURIComponent(headingId);
	}

	function updateStructuredData(block, items) {
		var script = block.querySelector('[data-toc-schema]');

		if (!items.length) {
			if (script) {
				script.remove();
			}

			return;
		}

		if (!script) {
			script = document.createElement('script');
			script.type = 'application/ld+json';
			script.dataset.tocSchema = 'true';
			block.appendChild(script);
		}

		script.textContent = JSON.stringify({
			'@context': 'https://schema.org',
			'@type': 'ItemList',
			name: block.querySelector('.article-table-of-contents__title').textContent.trim(),
			itemListOrder: 'https://schema.org/ItemListOrderAscending',
			numberOfItems: items.length,
			itemListElement: items.map(function (item, index) {
				return {
					'@type': 'ListItem',
					position: index + 1,
					name: item.text,
					url: getHeadingUrl(item.id)
				};
			})
		});
	}

	function buildTableOfContents(block) {
		var levels = (block.dataset.tocHeadings || '')
			.split(',')
			.map(function (level) { return level.trim(); })
			.filter(Boolean);

		var list = block.querySelector('[data-toc-list]');
		if (!list || !levels.length) {
			block.hidden = true;
			return;
		}

		var article = block.closest('article') || document;
		var content = article.querySelector('.post-content');
		if (!content) {
			block.hidden = true;
			return;
		}

		var headings = Array.prototype.slice.call(content.querySelectorAll(levels.join(','))).filter(function (heading) {
			return heading.textContent.trim().length > 0;
		});

		if (!headings.length) {
			block.hidden = true;
			return;
		}

		var nested = block.dataset.tocNested === 'true';
		var minLevel = Math.min.apply(null, headings.map(function (heading) {
			return Number(heading.tagName.substring(1));
		}));
		var usedIds = {};
		var counters = {};
		var flatCounter = 0;
		var previousItem = null;
		var offset = Math.max(parseInt(block.dataset.tocOffset, 10) || 0, 0);
		var structuredDataItems = [];

		list.replaceChildren();

		headings.forEach(function (heading) {
			var level = Number(heading.tagName.substring(1));
			var depth = nested ? Math.max(level - minLevel, 0) : 0;
			var item = { depth: depth };
			var headingText = heading.textContent.trim();
			var itemNumber = getItemNumber(item, previousItem, counters, flatCounter, nested);
			var listItem = document.createElement('li');
			var link = document.createElement('a');
			var number = document.createElement('span');
			var text = document.createElement('span');

			if (!heading.id) {
				heading.id = getUniqueId(slugify(headingText), usedIds);
			}

			structuredDataItems.push({
				id: heading.id,
				text: headingText
			});

			listItem.className = 'article-table-of-contents__item';
			listItem.style.setProperty('--toc-depth', depth);
			link.className = 'article-table-of-contents__link';
			link.href = '#' + encodeURIComponent(heading.id);
			link.addEventListener('click', function (event) {
				event.preventDefault();
				scrollToHeading(heading, offset);
			});
			number.className = 'article-table-of-contents__number';
			number.textContent = String(itemNumber).padStart(2, '0');
			text.className = 'article-table-of-contents__text';
			text.textContent = headingText;

			link.appendChild(number);
			link.appendChild(text);
			listItem.appendChild(link);
			list.appendChild(listItem);

			flatCounter += 1;
			previousItem = item;
		});

		updateStructuredData(block, structuredDataItems);
		block.hidden = false;
	}

	function initTableOfContents(container) {
		Array.prototype.slice.call((container || document).querySelectorAll('[data-article-toc]')).forEach(buildTableOfContents);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initTableOfContents(document);
		});
	} else {
		initTableOfContents(document);
	}

	document.addEventListener('shopify:section:load', function (event) {
		initTableOfContents(event.target);
	});
}());